module.exports = __webpack_public_path__ + "b08190ae713caacc459bc156f8d1702a.svg";